import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Code section
 */
const Code = (props) => {
  const { className, children, ...otherProps } = props;
  const classNames = classnames('code', className);

  return (
    <div className={classNames} {...otherProps}>
      {children}
    </div>
  );
};

Code.propTypes = {
  /** Additional classes. */
  className: PropTypes.string,
  /** Accordion sections */
  children: PropTypes.any.isRequired,
};

Code.defaultProps = {
  className: '',
};

export { Code };
